import React from "react";
import styled, { css } from "styled-components";
import { t } from "js/i18n";

const ReadOnlyBadgeIcon = styled.div<{ $quiet?: boolean }>`
    background: ${({ $quiet }) => $quiet ? "#F5F5F5" : "#111827CC"};
    color: ${({ $quiet }) => $quiet ? "#666" : "white"};
    padding: ${({ $quiet }) => $quiet ? "4px 6px" : "6px"};
    font-size: 9px;
    white-space: nowrap;
    border-radius: 3px;
    font-weight: 600;
    letter-spacing: 0.5px;
    text-transform: uppercase;
    line-height: 100%;
    align-self: flex-start;
    ${({ $quiet }) => $quiet && css`border: 1px solid #DDD;`}
`;

const ReadOnlyBadge = ({ quiet = false }: { quiet?: boolean }) => {
    return (
        <ReadOnlyBadgeIcon data-testid="view-only-badge" $quiet={quiet}>
            {t("view_only")}
        </ReadOnlyBadgeIcon>);
};

export default ReadOnlyBadge;
